import "./LocationsBanner.scss";
import MainAppLocationIcon from "../icons/MainAppLocationIcon";
import LocationPriceText from "./misc/LocationPriceText";

export default function LocationsBanner() {
  return (
    <section className={"promo-banner locations-banner"}>
      <h3>My Locations</h3>
      <LocationPriceText/>
      <div className={"circle"}>
        <MainAppLocationIcon color="#565656"/>
      </div>
    </section>
  );
}
